import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Resize } from 'vuetify/lib/directives';

const brandBlue = '#005695';
const brandYellow = '#fbb033';
const darkBlue = '#1a3966';
const lightBlue = '#0096d6';

const lightTheme = {
  primary: brandBlue,
  secondary: darkBlue,
  accent: brandYellow,
  error: '#FF5252',
  info: lightBlue,
  success: '#4CAF50',
  warning: '#ff7912'
};

const options = {
  // iconfont: 'md',
  theme: {
    themes: {
      light: lightTheme,
    },
    ripple: false,
  },
  directives: {
    Resize,
  },
  icons: {
    iconfont: 'mdi',
  },
};

Vue.use(Vuetify, options);

export default new Vuetify(options);
